import { httpPost, httpGet, httpPut, httpDelete } from "utils/httpRequest"

const getAllEvents = async ({ page, limit, search, eventType, tierProgramId, platform, status, isFeatured, isActive, hidePastEvents, sortBy, sortOrder }) => {
  console.log("getAllEvents called with params:", { page, limit, search, eventType, tierProgramId, platform, status, isFeatured, isActive, hidePastEvents, sortBy, sortOrder })
  // IMPORTANT: axios requires query params under `params`
  const resp = await httpGet("admin/event/getAll", {
    params: {
      page,
      limit,
      search,
      eventType,
      tierProgramId,
      platform,
      status,
      isFeatured,
      isActive,
      hidePastEvents,
      sortBy,
      sortOrder,
    }
  })
  console.log("getAllEvents response:", resp)
  return resp
}

const getEventById = async (id) => {
  const resp = await httpGet(`admin/event/getById/${id}`)
  return resp
}

const getEventRegistrations = async ({ eventId, page, limit, search }) => {
  const resp = await httpGet(`admin/event/registrations/${eventId}`, {
    params: {
      page,
      limit,
      ...(search ? { search } : {}),
    },
  })
  return resp
}

const createEvent = async ({
  title,
  description,
  shortDescription,
  imageUrl,
  startDate,
  endDate,
  registrationStartDate,
  registrationEndDate,
  maxParticipants,
  tierAccess,
  tierProgramId, // Added tierProgramId parameter
  productProgramId,
  categoryId,
  eventType,
  platform,
  externalEventId,
  meetingUrl,
  meetingPassword,
  zoomJoinLink,
  isFeatured,
  isActive,
  sortOrder,
  autoRegisterExternal,
  audienceEmailsEnabled,
  newMemberEmailsEnabled,
  tags,
  location,
  timezone,
  externalRegistrationData,
  // AEvent IDs and Internal Event UIDs
  hubspotEventRegistrantId,
  hubspotEventProductId,
  hubspotEventId,
  aeventCalendarId,
  aeventWtlId,
}) => {
  const resp = await httpPost("admin/event/create", {
    title,
    description,
    shortDescription,
    imageUrl,
    startDate,
    endDate,
    registrationStartDate,
    registrationEndDate,
    maxParticipants,
    tierAccess,
    tierProgramId, // Added tierProgramId to the request
    productProgramId,
    categoryId,
    eventType,
    platform,
    externalEventId,
    meetingUrl,
    meetingPassword,
    zoomJoinLink,
    isFeatured,
    isActive,
    sortOrder,
    autoRegisterExternal,
    audienceEmailsEnabled,
    newMemberEmailsEnabled,
    tags,
    location,
    timezone,
    externalRegistrationData,
    // AEvent IDs and Internal Event UIDs
    hubspotEventRegistrantId,
    hubspotEventProductId,
    hubspotEventId,
    aeventCalendarId,
    aeventWtlId,
  })
  return resp
}

const updateEvent = async (id, {
  title,
  description,
  shortDescription,
  imageUrl,
  startDate,
  endDate,
  registrationStartDate,
  registrationEndDate,
  maxParticipants,
  tierAccess,
  tierProgramId, // Added tierProgramId parameter
  productProgramId,
  categoryId,
  eventType,
  platform,
  externalEventId,
  meetingUrl,
  meetingPassword,
  zoomJoinLink,
  isFeatured,
  isActive,
  sortOrder,
  autoRegisterExternal,
  audienceEmailsEnabled,
  newMemberEmailsEnabled,
  tags,
  location,
  timezone,
  externalRegistrationData,
  status,
  // AEvent IDs and Internal Event UIDs
  hubspotEventRegistrantId,
  hubspotEventProductId,
  hubspotEventId,
  aeventCalendarId,
  aeventWtlId,
}) => {
  const resp = await httpPut(`admin/event/update/${id}`, {
    title,
    description,
    shortDescription,
    imageUrl,
    startDate,
    endDate,
    registrationStartDate,
    registrationEndDate,
    maxParticipants,
    tierAccess,
    tierProgramId, // Added tierProgramId to the request
    productProgramId,
    categoryId,
    eventType,
    platform,
    externalEventId,
    meetingUrl,
    meetingPassword,
    zoomJoinLink,
    isFeatured,
    isActive,
    sortOrder,
    autoRegisterExternal,
    audienceEmailsEnabled,
    newMemberEmailsEnabled,
    tags,
    location,
    timezone,
    externalRegistrationData,
    status,
    // AEvent IDs and Internal Event UIDs
    hubspotEventRegistrantId,
    hubspotEventProductId,
    hubspotEventId,
    aeventCalendarId,
    aeventWtlId,
  })
  return resp
}

const deleteEvent = async (id) => {
  const resp = await httpDelete(`admin/event/delete/${id}`)
  return resp
}

const getAudienceEmailEstimate = async ({
  tierProgramId,
  productProgramId,
  eventId,
  seriesType,
}) => {
  const resp = await httpPost("admin/event/audienceEmailEstimate", {
    tierProgramId,
    ...(productProgramId ? { productProgramId } : {}),
    ...(eventId ? { eventId } : {}),
    ...(seriesType ? { seriesType } : {}),
  })
  return resp.data
}

const createZoomMeeting = async ({
  title,
  startDate,
  endDate,
  timezone,
  shortDescription,
  description,
  eventTemplate,
  alternativeHosts,
}) => {
  const resp = await httpPost("admin/event/zoom/createMeeting", {
    title,
    startDate,
    endDate,
    timezone,
    shortDescription,
    description,
    eventTemplate,
    alternativeHosts,
  })
  return resp
}

// Pull the Zoom participant report and mark matching registrations attended
// With eventId: syncs one event. Without eventId: bulk-syncs all ended Zoom
// events (optionally bounded by startAt/endAt epoch ms).
const syncZoomAttendance = async ({ eventId, startAt, endAt, markNoShows }) => {
  const payload = {}
  if (eventId) {
    payload.eventId = eventId
  }
  if (startAt) {
    payload.startAt = startAt
  }
  if (endAt) {
    payload.endAt = endAt
  }
  if (markNoShows) {
    payload.markNoShows = true
  }
  const resp = await httpPost("admin/event/zoom/syncAttendance", payload)
  return resp.data
}

export {
  getAllEvents,
  getEventById,
  getEventRegistrations,
  createEvent,
  updateEvent,
  deleteEvent,
  createZoomMeeting,
  syncZoomAttendance,
  getAudienceEmailEstimate,
}